import { Scale, Gavel, Briefcase } from 'lucide-react';

export const practiceAreas = [
  {
    id: 'family-matters',
    title: 'Family Matters',
    icon: Scale,
    description: 'Divorce, Maintenance & Alimony, Child Custody, Domestic Violence Cases, Property Disputes within Families',
    link: '/practices/family-matters',  // Direct link to Family Matters page
    color: 'gold'
  },
  {
    id: 'civil-matters',
    title: 'Civil Matters',
    icon: Gavel,
    description: 'Property Disputes, Recovery of Money, Cheque Bounce Cases (NI Act), Breach of Contract, Consumer Protection',
    link: '/practices/civil-matters',  // Direct link to Civil Matters page
    color: 'gold'
  },
  {
    id: 'criminal-matters',
    title: 'Criminal Matters',
    icon: Briefcase,
    description: 'Bail Applications, Criminal Defense, Court Representation in High Court and Lower Courts',
    link: '/practices/criminal-matters',  // Direct link to Criminal Matters page
    color: 'gold'
  }
];